export default {
  ru: {
    title: 'ВЫБОР АПАРТАМЕНТОВ',
  },

  en: {
    title: 'ВЫБОР АПАРТАМЕНТОВ',
  },
};
